import { Box, Typography } from '@mui/material';

import { EpisodeCountIcon } from '@/icons';

interface EpisodeCountProps {
  episodeCount: number;
  completions: number;
}

export const EpisodeCountWithCompletions = ({
  episodeCount,
  completions,
}: EpisodeCountProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 0.25,
        flexDirection: 'row',
        alignItems: 'center',
      }}>
      <Box>
        <EpisodeCountIcon sx={{ color: 'text.main', width: 12, height: 12 }} />
      </Box>
      <Typography variant="caption1Bold" color="text.main">
        {completions === 0
          ? `${episodeCount} Episodes`
          : `${completions}/${episodeCount} Completed`}
      </Typography>
    </Box>
  );
};
